document.addEventListener('ControllerReady', () => {
    document.querySelectorAll('.hero-banner').forEach(($hero) => {
        const $slider = $hero.querySelector('.hero-slider');
        const $cardsContainer = $slider.querySelector('.cards');
        const $controls = $hero.querySelector('.controls');
        const $scroller = $hero.querySelector('.scroll-down');
        const $navContainer = $hero.querySelector('.nav-buttons');
        const heroRect = $hero.getBoundingClientRect();
        let $cards = $slider.querySelectorAll('.hero-card');
        let dummyCards = false;
        let currSlide = 0;
        if ($cards) {
            $cards.forEach((card) => {
                if ((card.dataset.publishon && card.dataset.publishon > getFormattedDate(new Date())) || (card.dataset.unpublishon && card.dataset.unpublishon < getFormattedDate(new Date()))) {
                    $cardsContainer.removeChild(card);
                }
            });
            $cards = $slider.querySelectorAll('.hero-card');
        }
        if ($cards && $cards.length === 2) {
            $cards.forEach((card) => {
                const $dummy = card.cloneNode(true);
                $cardsContainer.appendChild($dummy);
            });
            $cards = $slider.querySelectorAll('.hero-card');
            dummyCards = true;
        }
        function getFormattedDate(date) {
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0'); 
            var hh = String(date.getHours()).padStart(2, '0');
            var mi = String(date.getMinutes()).padStart(2, '0');
            var yyyy = date.getFullYear();
            return mm + '/' + dd + '/' + yyyy + ' ' + hh + ':' + mi;
        }
        init($cards, $slider, $controls, currSlide);
        if ($slider.classList.contains('active')) {
            const hammer = new Hammer($slider, {});
            hammer.on('swipeleft', () => {
                if ($cards && $cards.length > 1) {
                    currSlide = currSlide + 1 < $cards.length ? currSlide + 1 : 0;
                    cycle($cards, currSlide);
                    transitionSync($slider);
                }
            });
            hammer.on('swiperight', () => {
                if ($cards && $cards.length > 1) {
                    currSlide = currSlide > 0 ? currSlide - 1 : $cards.length - 1;
                    cycle($cards, currSlide);
                    transitionSync($slider);
                }
            });
        }
        $controls.querySelector('.left').addEventListener('click', () => {
            if ($cards && $cards.length > 1) {
                currSlide = currSlide > 0 ? currSlide - 1 : $cards.length - 1;
                cycle($cards, currSlide);
                transitionSync($slider);
            }
        });
        $controls.querySelector('.right').addEventListener('click', () => {
            if ($cards && $cards.length > 1) {
                currSlide = currSlide + 1 < $cards.length ? currSlide + 1 : 0;
                cycle($cards, currSlide);
                transitionSync($slider);
            }
        });
        function init($cards, $slider, $controls, currSlide) {
            const len = $cards.length;
            if (len > 1) {
                setNavButtons();
                cycle($cards, currSlide);
                $slider.classList.add('active');
                $controls.classList.remove('hidden');
            }
            else {
                if ($cards && $cards.length === 1) {
                    $cards[0].classList.add('curr');
                }
                $controls.classList.add('hidden');
            }
        }
        function cycle($cards, currSlide) {
            const len = $cards.length;
            let normCurrSlide = $cards[currSlide] ? currSlide : len - 1;
            const next = normCurrSlide + 1 < len ? normCurrSlide + 1 : 0;
            const prev = normCurrSlide - 1 >= 0 ? normCurrSlide - 1 : len - 1;
            $navContainer.querySelectorAll('.nav-item').forEach((navItem, index) => {
                if ((dummyCards && index === normCurrSlide % 2) || index === normCurrSlide) {
                    navItem.classList.add('active');
                }
                else {
                    navItem.classList.remove('active');
                }
            });
            $cards.forEach(($card) => {
                $card.classList.remove('curr', 'next', 'prev');
            });
            $cards[normCurrSlide].classList.add('curr');
            $cards[next].classList.add('next');
            $cards[prev].classList.add('prev');
        }
        function transitionSync($slider) {
            $slider.classList.add('transitioning');
            if ($slider.sync) {
                clearTimeout(sync);
            }
            $slider.sync = setTimeout(() => {
                $slider.classList.remove('transitioning');
                $slider.sync = false;
            }, 500);
        }
        function setNavButtons() {
            if ($cards && $cards.length) {
                const normLength = dummyCards ? 2 : $cards.length;
                for (let index = 0; index < normLength; index++) {
                    let navItem = document.createElement('li');
                    navItem.className =
                        currSlide === index ? 'nav-item active' : 'nav-item';
                    navItem.setAttribute('aria-label', 'card-' + index);
                    navItem.setAttribute('role', 'button');
                    navItem.tabIndex = 0;
                    navItem.addEventListener('click', function () {
                        currSlide = index;
                        cycle($cards, currSlide);
                        transitionSync($slider);
                    });
                    $navContainer.appendChild(navItem);
                }
            }
        }
    });
});
